

import axiosInstance from '../../config';

// async funtion for make smoother and faster without waiting of acknowledgement
export const removeCopierUserService = async (data, token) => {
    try {
        const response = await axiosInstance.post(
            '/copier/remove_copier_user',
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }
        );



        return {
            success: true,
            data: response.data, //return data response
            status: response.status,// retun status 
        };
    } catch (error) {

        // Optional for debugging

        return {
            success: false,
            message: error.response?.data?.message || 'Remove failed',
            status: error.response?.status || 500,
            errors: error.response?.data?.errors || null,
        };
    }
};
